import { isIP } from '@/utils/validate'

const localHosts = ['localhost', '127.0.0.1', '0.0.0.0', '::1']

export function isIllegalAccessLocation(location = window.location) {
  const { hostname, port, protocol } = location

  if (process.env.NODE_ENV !== 'production' || localHosts.includes(hostname)) return false

  return protocol === 'http:' || isIP(hostname) || !!port
}
